export default {"src":"/_next/static/media/metamask.b3a80d89.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};